import { PeriscopeList } from '@periscopes/general';
import { PeriscopeTagList } from '@periscopes/general/tags';
import React, { useCallback } from 'react';

export interface PardotFieldTagsTabProps {
	index: number;
	tagIds: Array<number>;
}

export const PardotFieldTagsTab: React.FC<PardotFieldTagsTabProps> = ({ index, tagIds }) => {
	const renderTags = useCallback(
		(data: Array<number>) => <PeriscopeTagList
			parentIndex={ index }
			tagIds={ data } />,
		[ index ]
	);

	return <PeriscopeList
		list={ renderTags }
		loading={ false }
		results={ tagIds } />;
};
